var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('task',{attrs:{"type":6,"keyID":"CFE99D4552E117C5B7A0B01E3B56064C"}})}
var staticRenderFns = []

export { render, staticRenderFns }